/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import InvestmentStyleDiagnosisAgentAllOfAnswerLabels from './InvestmentStyleDiagnosisAgentAllOfAnswerLabels';

/**
 * The InvestmentStyleDiagnosisAgentAllOf model module.
 * @module model/InvestmentStyleDiagnosisAgentAllOf
 * @version 1.0.0
 */
class InvestmentStyleDiagnosisAgentAllOf {
    /**
     * Constructs a new <code>InvestmentStyleDiagnosisAgentAllOf</code>.
     * @alias module:model/InvestmentStyleDiagnosisAgentAllOf
     */
    constructor() { 
        
        InvestmentStyleDiagnosisAgentAllOf.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InvestmentStyleDiagnosisAgentAllOf</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InvestmentStyleDiagnosisAgentAllOf} obj Optional instance to populate.
     * @return {module:model/InvestmentStyleDiagnosisAgentAllOf} The populated <code>InvestmentStyleDiagnosisAgentAllOf</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InvestmentStyleDiagnosisAgentAllOf();

            if (data.hasOwnProperty('answer_labels')) {
                obj['answer_labels'] = InvestmentStyleDiagnosisAgentAllOfAnswerLabels.constructFromObject(data['answer_labels']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>InvestmentStyleDiagnosisAgentAllOf</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>InvestmentStyleDiagnosisAgentAllOf</code>.
     */
    static validateJSON(data) {
        // validate the optional field `answer_labels`
        if (data['answer_labels']) { // data not null
          InvestmentStyleDiagnosisAgentAllOfAnswerLabels.validateJSON(data['answer_labels']);
        }

        return true;
    }


}



/**
 * @member {module:model/InvestmentStyleDiagnosisAgentAllOfAnswerLabels} answer_labels
 */
InvestmentStyleDiagnosisAgentAllOf.prototype['answer_labels'] = undefined;






export default InvestmentStyleDiagnosisAgentAllOf;

